import ApplicationController from './application_controller';
import axios from 'axios';
import autocomplete from 'autocomplete.js';
import { escapeAutocompleteHtml } from '../utils/autocomplete';

const MIN_QUERY_LENGTH = 2;

export default class extends ApplicationController {
  static targets = ['transporter', 'originInput', 'originId', 'destinationInput', 'destinationId'];
  static values = { searchUrl: String };

  connect() {
    this.addAutocomplete(this.originInputTarget, this.originIdTarget);
    this.addAutocomplete(this.destinationInputTarget, this.destinationIdTarget);
  }

  // Terminal ids are scoped to a provider, so changing it invalidates both picks.
  transporterChanged() {
    [this.originInputTarget, this.destinationInputTarget].forEach((el) => { el.value = ''; });
    [this.originIdTarget, this.destinationIdTarget].forEach((el) => { el.value = ''; });
  }

  keydown(event) {
    if (event.key == 'Enter') {
      event.preventDefault();
    }
  }

  addAutocomplete(inputTarget, hiddenTarget) {
    const ac = autocomplete(inputTarget, { hint: false, autoselect: true }, [
      {
        source: this.source(),
        debounce: 200,
        templates: {
          suggestion: function (suggestion) {
            return escapeAutocompleteHtml(suggestion.label || suggestion.code || 'Invalid suggestion data');
          },
        },
      },
    ]).on('autocomplete:selected', (event, suggestion) => {
      ac.autocomplete.setVal(suggestion.label);
      hiddenTarget.value = suggestion.id;
    });

    // Free typing must not leave a stale id behind.
    inputTarget.addEventListener('input', () => { hiddenTarget.value = ''; });
    inputTarget.addEventListener('keydown', this.keydown.bind(this));
  }

  source() {
    return (q, callback) => {
      const transporterId = this.transporterTarget.value;

      if (!transporterId || q.length < MIN_QUERY_LENGTH) {
        callback([]);
        return;
      }

      axios
        .get(this.searchUrlValue, { params: { q, transporter_id: transporterId } })
        .then((response) => callback(response.data))
        .catch(() => callback([]));
    };
  }
}
